<template>
  <!--div class="parent" style="overflow:auto" v-bind:style="{ height: pageHeight + 'px'}"-->
  <div class="parent">
    <transition :name="transitionName">
      <router-view class="child-view"></router-view>
    </transition>
  </div>
</template>

<script>

export default {
  data() {
    return {
      transitionName: "slide-left"
    };
  },
  computed: {
    pageHeight() {
      return window.innerHeight - (this.info.navbar ? 44 : 0);
    },
    info() {
      return this.$root.info;
    }
  },
  beforeRouteUpdate(to, from, next) {
    // console.log(to.path, from.path);
    this.$root.beforeRouteUpdate();
    const toDepth = to.path.split("/").filter(function(n) {
      return n != "";
    }).length;
    const fromDepth = from.path.split("/").filter(function(n) {
      return n != "";
    }).length;
    this.transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
    if (
      (to.path == "/cart" && from.path != "/checkout") ||
      to.path == "/checkout" ||
      to.path == "/coupon"
    )
      this.transitionName = "slide-left";
    else if (
      from.path == "/cart" ||
      from.path == "/checkout" ||
      from.path == "/coupon"
    )
      this.transitionName = "slide-right";
    this.info.canGoBack = toDepth > 0;
    next();
  }
};
</script>

<style>
.child-view {
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
  width: 100%;
  height: 100%;
}

.slide-left-enter,
.slide-right-leave-active {
  position: absolute;
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}
.slide-left-leave-active,
.slide-right-enter {
  position: absolute;
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fadeFast-enter-active,
.fadeFast-leave-active {
  transition: opacity 0.2s;
}
.fadeFast-enter,
.fadeFast-leave-to {
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
}
.slide-up-enter,
.slide-up-leave-to {
  opacity: 0;
  transform: translate(0, 30px);
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
}
.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translate(0, -30px);
}

.slide-fromleft-enter-active,
.slide-fromleft-leave-active {
  transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
}
.slide-fromleft-enter,
.slide-fromleft-leave-to {
  opacity: 0;
  transform: translate(-30px, 0);
}

.slide-fromright-enter-active,
.slide-fromright-leave-active {
  transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
}
.slide-fromright-enter,
.slide-fromright-leave-to {
  opacity: 0;
  transform: translate(30px, 0);
}

.fixed-bottom-fix {
  transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
}

.slide-left-leave-active .fixed-bottom-fix,
.slide-right-leave-active .fixed-bottom-fix {
  display: none;
}
.slide-left-enter-active .fixed-bottom-fix,
.slide-right-enter-active .fixed-bottom-fix {
  opacity: 0;
}

</style>
